import React from 'react'
import { ArticlePublication } from 'common/client-data-types/publication'
import {
    InlineContentTypes,
    InlinePointer,
} from 'component-library/templates/Publication/SharedPublication.routing'
import { Topic } from 'common/client-data-types/topic'
import { InlinePositionedContent } from 'component-library/templates/Publication/Publication.props'
import { Pointer } from 'component-library/content/Pointer/Pointer'

export interface GetInlinePositionedContentProps {
    publication: ArticlePublication
    inlinePublicationContent: InlineContentTypes[]
}

export function isInlinePointer(content: InlineContentTypes): content is InlinePointer {
    return content.kind === 'pointer'
}

// We need to match the article topic to either "business/n" or "news/wa".
const matchArticleTopics = (primaryTopic: Topic, secondaryTopics: Topic[]): boolean => {
    const primary = /business+(?=\/)|^news\/wa/i.test(primaryTopic.id)
    const secondary =
        secondaryTopics &&
        secondaryTopics.some(topic => /business+(?=\/)|^news\/wa/i.test(topic.id))
    return primary ? primary : secondary
}

export const getInlinePositionedPointer = (props: GetInlinePositionedContentProps) => {
    const { publication, inlinePublicationContent } = props

    // Should be an article and either tagged with "Business" or "WA News".
    if (
        publication.kind !== 'article' ||
        !matchArticleTopics(publication.primaryTopic, publication.secondaryTopics)
    ) {
        return []
    }

    return inlinePublicationContent
        .filter(isInlinePointer)
        .reduce((acc: InlinePositionedContent[], content: InlinePointer) => {
            const position = content.insertAfter
            const mappedAdContent = {
                position,
                element: (
                    <Pointer
                        pointerLinkUrl={content.props.pointerLinkUrl}
                        pointerImageSrc={content.props.pointerImageSrc}
                        pointerImageAlt={content.props.pointerImageAlt}
                    />
                ),
            }
            acc.push(mappedAdContent)
            return acc
        }, [])
}
